<!-- Error Views -->
<app-module-error *ngIf="isNoMetric" [noMetric]="true"></app-module-error>
<app-module-error class="flex-fill" *ngIf="isTooMuchData" [tooMuchData]="true"></app-module-error>
<app-module-error *ngIf="isDateRangeTooWideIntraday" [dateRangeTooWideIntraday]="true"></app-module-error>
<app-module-error *ngIf="isNoData" [noData]="true"></app-module-error>

<div class="gridItemChildModule w-100 h-100 d-flex flex-column">
    <!-- Place main body content here -->
    <!-- Search -->
    <div *ngIf="!config.isCxOne" class="w-75 mx-auto my-2 search-box live-search" [hidden]="!showFilter">
        <input type="search" class="form-control"
            autocomplete="off"
            [(ngModel)]="filterValue"
            (ngModelChangeDebounced)="applyFilter()"
            [ngModelChangeDebounceTime]="500"
            placeholder="Search..."
            cvLocalizedPlaceholder
            [langSection]="'Subscriptions_Management'"
            [langKey]="'Search'"
        />
        <span class="clear-input" role="button" tabindex="0"
            [hidden]="filterValue.length === 0"
            (click)="clearFilter()">
        </span>
    </div>

    <!-- Search cxone -->
    <div *ngIf="config.isCxOne" class="cxone-live-search ml-2 my-2" [hidden]="!showFilter">
        <sol-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search"
            (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="500"></sol-text-input>
        <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
            <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                <use href="../App_Themes/CXone/icons/search.svg#search"></use>
            </svg>
        </i>
        <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
            <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                <use href="../App_Themes/CXone/icons/close.svg#close"></use>
            </svg>
        </i>
    </div>
        

    <!-- Sample ag-grid.  Remove if unneeded. -->
    <ag-grid-angular #expandedSummaryWidgetGrid *ngIf="gridOptions != null" [hidden]="!config.isCxOne && !this.isDataFirstLoaded" class="ag-theme-balham flex-fill" [gridOptions]="gridOptions"></ag-grid-angular>
</div>
